var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5088_4627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 13.3333C2.58667 13.3333 3.33333 12.5883 3.33333 11.6667V5C3.33333 4.08 4.08167 3.33333 5 3.33333H11.6667C12.5867 3.33333 13.3333 2.58833 13.3333 1.66667C13.3333 0.745 12.5867 0 11.6667 0H5C2.24333 0 0 2.24333 0 5V11.6667C0 12.5883 0.746667 13.3333 1.66667 13.3333Z",
    fill: "#264653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 40H11.6667C12.5867 40 13.3333 39.255 13.3333 38.3333C13.3333 37.4116 12.5867 36.6666 11.6667 36.6666H5C4.08167 36.6666 3.33333 35.92 3.33333 35V28.3333C3.33333 27.4116 2.58667 26.6666 1.66667 26.6666C0.746666 26.6666 0 27.4116 0 28.3333V35C0 37.7566 2.24333 40 5 40Z",
    fill: "#264653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3332 40H34.9998C37.7565 40 39.9998 37.7566 39.9998 35V28.3333C39.9998 27.4116 39.2532 26.6666 38.3332 26.6666C37.4132 26.6666 36.6665 27.4116 36.6665 28.3333V35C36.6665 35.92 35.9182 36.6666 34.9998 36.6666H28.3332C27.4132 36.6666 26.6665 37.4116 26.6665 38.3333C26.6665 39.255 27.4132 40 28.3332 40Z",
    fill: "#264653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3332 13.3333C39.2532 13.3333 39.9998 12.5883 39.9998 11.6667V5C39.9998 2.24333 37.7565 0 34.9998 0H28.3332C27.4132 0 26.6665 0.745 26.6665 1.66667C26.6665 2.58833 27.4132 3.33333 28.3332 3.33333H34.9998C35.9182 3.33333 36.6665 4.08 36.6665 5V11.6667C36.6665 12.5883 37.4132 13.3333 38.3332 13.3333Z",
    fill: "#264653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 29.0284V24.8617C8.3335 23.9401 9.08016 23.1951 10.0002 23.1951H30.0002C30.9202 23.1951 31.6668 23.9401 31.6668 24.8617V29.0284C31.6668 30.8667 30.1718 32.3617 28.3335 32.3617H11.6668C9.8285 32.3617 8.3335 30.8667 8.3335 29.0284Z",
    fill: "#121B26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 16.6667V11.6667C8.3335 9.82837 9.8285 8.33337 11.6668 8.33337H28.3335C30.1718 8.33337 31.6668 9.82837 31.6668 11.6667V16.6667C31.6668 17.5884 30.9202 18.3334 30.0002 18.3334H10.0002C9.08016 18.3334 8.3335 17.5884 8.3335 16.6667Z",
    fill: "#121B26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 25H33.3333C34.2533 25 35 24.255 35 23.3333C35 22.4116 34.2533 21.6666 33.3333 21.6666H6.66667C5.74667 21.6666 5 22.4116 5 23.3333C5 24.255 5.74667 25 6.66667 25Z",
    fill: "#264653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 0H5C2.24333 0 0 2.24333 0 5V11.6667C0 12.5883 0.746667 13.3333 1.66667 13.3333C2.58667 13.3333 3.33333 12.5883 3.33333 11.6667V5C3.33333 4.08 4.08167 3.33333 5 3.33333H11.6667C12.5867 3.33333 13.3333 2.58833 13.3333 1.66667C13.3333 0.745 12.5867 0 11.6667 0Z",
    fill: "#121B26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 26.6666C0.746666 26.6666 0 27.4116 0 28.3333V35C0 37.7566 2.24333 40 5 40H11.6667C12.5867 40 13.3333 39.255 13.3333 38.3333C13.3333 37.4116 12.5867 36.6666 11.6667 36.6666H5C4.08167 36.6666 3.33333 35.92 3.33333 35V28.3333C3.33333 27.4116 2.58667 26.6666 1.66667 26.6666Z",
    fill: "#121B26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 25H8.3335V29.0283C8.3335 30.8667 9.8285 32.3617 11.6668 32.3617H20.0002V25Z",
    fill: "#264653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 8.33337H11.6668C9.8285 8.33337 8.3335 9.82837 8.3335 11.6667V16.6667C8.3335 17.5884 9.08016 18.3334 10.0002 18.3334H20.0002V8.33337Z",
    fill: "#264653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 21.6666H6.66667C5.74667 21.6666 5 22.4116 5 23.3333C5 24.255 5.74667 25 6.66667 25H8.33333H20V21.6666Z",
    fill: "#121B26"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5088_4627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanner);
export default __webpack_public_path__ + "static/media/Scanner.08acbd4e636bd2629c6fb104780457e9.svg";
export { ForwardRef as ReactComponent };